import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { Power } from 'react-feather';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { Tooltip, Menu, MenuItem, IconButton as MuiIconButton, Button, Box, Divider } from '@mui/material';

import useAuth from '../../hooks/useAuth';
import { ACCESS_TOKEN_USER } from '../../const';

const UserMenuContainer = styled(Box)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  padding: ${(props) => props.theme.spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(1)};
`;

const IconButton = styled(MuiIconButton)`
  color: ${(props) => props.theme.sidebar.color};
  svg {
    width: 22px;
    height: 22px;
  }
`;

const AdminButton = styled(Button)`
  background-color: transparent;
  color: ${(props) => props.theme.sidebar.color};
  font-size: 12px;
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const SidebarUserMenu = () => {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate();
  const { signOut, setUserMe, signOutAsUser } = useAuth();
  const isUserView = useMemo(
    () => window.localStorage.getItem(ACCESS_TOKEN_USER),
    [window.localStorage.getItem(ACCESS_TOKEN_USER)],
  );

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    await signOut();
    setUserMe(null);
    navigate('/auth/sign-in');
  };

  return (
    <>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.12)' }} />
      <UserMenuContainer>
        {isUserView && (
          <AdminButton
            fullWidth
            onClick={() => {
              signOutAsUser();
              window.location.href = '/admin/users';
            }}>
            Gå till Admin
          </AdminButton>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Tooltip title="Account">
            <IconButton
              aria-owns={anchorMenu ? 'menu-sidebar-account' : undefined}
              aria-haspopup="true"
              onClick={toggleMenu}
              size="large">
              <Power />
            </IconButton>
          </Tooltip>
        </Box>
        <Menu
          id="menu-sidebar-account"
          anchorEl={anchorMenu}
          open={Boolean(anchorMenu)}
          onClose={closeMenu}>
          <MenuItem onClick={handleSignOut} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><LogoutIcon sx={{ fontSize: 16 }} /> Logga ut</MenuItem>
        </Menu>
      </UserMenuContainer>
    </>
  );
};

export default SidebarUserMenu;
